import React, { useEffect, useRef, useState } from "react";
import UserHighLights from "./components/UserHighLights";
import { FindUser } from "./components/FindUser";
import UserHighlightsSkeleton from "./components/UserHighlightsSkeleton";
import UsersHighlightsTopSkeleton from "./components/UsersHighlightsTopSkeleton";
import LeftScreenSkeleton from "./components/LeftScreenSkeleton";
import { User, usersCategory } from "./interface/User";
import { useFilter } from "./FindUserRole/useFilter";
import { usersApi } from "./API/users";
import { createPortal } from "react-dom";
import Modal from "./components/Modal";

interface countryPropsType {
  val: string;
  opt: string;
}

function App({ usersCategories, countries }: {
  usersCategories: usersCategory[]; countries: countryPropsType[]
}) {
  const [users, setUsers] = useState<User[]>([])
  const [gender, setGender] = useState('all')
  const [keyword, setKeyword] = useState('')
  const [displayProfile, setDisplayProfile] = useState<User | undefined>()
  const present = useRef(new Date().getFullYear())
  const [pageCount, setPageCount] = useState(0)
  const findByGender = useFilter({ keyword, users, getFilterResults: (keyword: string, users: User[] | undefined) => users?.filter(({ gender }) => gender.toLowerCase() === keyword.toLowerCase()) })
  const findByUsername = useFilter({ keyword, users, getFilterResults: (keyword: string, users: User[] | undefined) => users?.filter(({ name: { first, last } }, idx) => `${first} ${last}`.toLowerCase().includes(keyword.toLowerCase())) })
  const getSearchFunction = () => (gender === 'all') ? findByUsername(keyword, users.slice(pageCount * 10, ((pageCount + 1) * 10))) : findByGender(gender, users.slice(pageCount * 10, ((pageCount + 1) * 10)))

  const getOpacity = (category: string) => gender === category ? 1 : 0
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGender('all')
    setKeyword(e.target.value)
  }
  const onChangeHandlerCallback = (e: React.ChangeEvent<HTMLInputElement>) => onChangeHandler(e)
  useEffect(() => {
    fetch(`${usersApi}`)
      .then(data => data.json())
      .then(({ results }) => setUsers(results))
  }, []
  )

  return (
    <React.Fragment>
      {displayProfile && createPortal(<Modal displayProfile={displayProfile} setDisplayProfile={() => { setDisplayProfile(undefined) }} />, document.getElementById('modalContainer') as HTMLElement)}
      <div className="App">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="left-wrapper" style={{ position: 'relative', height: '100vh' }}>
                <div className="container-fluid right-top" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
                  {!users.length ? <LeftScreenSkeleton /> : <><div className="container ">
                    <div className="hello-emerald left-page" style={{ width: '90%' }}>
                      <h2><span className="display-4">Hello,</span> Emerald</h2>
                      <p className="welcome-message">welcome to your dashboard, kindly sort through the user base</p>
                    </div>
                  </div>
                    <div className="container mb-5">
                      <div className="form-group">
                        <FindUser onChangeHandler={onChangeHandlerCallback} keyword={keyword} placeholder='Find user...' id='leftSearch' />
                      </div>
                    </div>
                    <div className="container">
                      <h6 className="show-user mb-3">Show users</h6><br />
                      <div className="container">
                        <div className="row" style={{ justifyContent: 'space-between', flexWrap: 'nowrap' }}>
                          {usersCategories.map(({ setGenderParam, category, faClass, id }) => <div key={id} className="users px-0" id={id}>
                            <div key={setGenderParam}>
                              <span onClick={() => {
                                setGender(setGenderParam)
                              }} className={`btn p-4 ${setGenderParam}`}><i className={`fa fa-${faClass}`} aria-hidden="true"></i></span>
                              <p className="mt-2">{category}</p>
                            </div>
                          </div>)}
                        </div>
                      </div>
                    </div></>}
                </div>
              </div>
            </div>
            <div className="col-md-6 p-3">
              <div className="container-fluid jumbotron">
                <div style={{ maxWidth: 'fit-content', margin: '0 auto' }}>
                  <div className="container">
                    <div className="row my-4 right-col-top">
                      {!users.length ? <UsersHighlightsTopSkeleton /> : <>
                        <div className="col-12">
                          <div className="userCategoryContainer mb-2" style={{ height: '3em' }}>
                            {[{ title: 'All Users', gender: 'all' }, { title: 'Male Users', gender: 'male' }, { title: 'Female Users', gender: 'female' }].map(({ title, gender }) => <h4 key={gender} className="" id="maleUsersCategory" style={{ opacity: getOpacity(gender), transition: 'all .4s' }}>{title}</h4>)}
                          </div>
                        </div>
                        <div className="col-sm-4 mb-2 align-items-center">
                          <h6>Filter by</h6>
                          <div className="right-search" style={{ display: 'flex', alignItems: 'center' }}>
                            <FindUser onChangeHandler={onChangeHandler} keyword={keyword} placeholder="search..." id='rightSearch' />
                          </div>
                        </div>
                        <div className="col-sm-4 mb-2 right-dropdown-container align-items-center">
                          <h6>Country</h6>
                          <div className="dropdown" style={{ display: 'flex', alignItems: 'center' }}>
                            <select onChange={(e) => { alert(e.target.value) }} style={{ background: 'initial', borderRadius: '.9em' }} id="country" name="country" className="form-control">
                              {countries.map(({ val, opt }) => <option key={opt} value={val}>{opt}</option>)}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-4 mb-2 align-items-center">
                          <h6>Show&nbsp;country</h6>
                          <div className="toggle-button right-toggle-container">
                            <div className="center">
                              <input type="checkbox" name="" />
                            </div>
                          </div>
                        </div></>}

                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row user-row">
                      <div className="col-12 userColumn">
                        {!users.length ? [1, 2, 3, 4, 5, 6, 7, 8, 9].map((id) => <UserHighlightsSkeleton key={id} />) : getSearchFunction()?.map(profile => <UserHighLights key={profile.email} profile={profile} showProfileDetails={() => setDisplayProfile(profile)} />)}
                      </div>
                    </div>
                    <div className="col-12 pt-4">
                      <div className="row">
                        <div className="col-8">
                          <button style={{ fontSize: "1em" }} className="btn download-results"><i
                            className="fa fa-cloud-download" aria-hidden="true"></i> Download
                            results</button>
                        </div>
                        <div className="col-4">
                          <div className="pager-container">
                            <ul className="pager pl-0 justify-content-end">
                              <li className="mr-2"><button disabled={pageCount === 0} onClick={() => { setPageCount(prev => --prev) }} className="btn pager-nonactive"><i className="fa fa-angle-double-left"
                                style={{ fontSize: ".8em" }} aria-hidden="true"></i></button></li>
                              <li><button disabled={pageCount === Math.ceil(users.length / 10) - 1} onClick={() => { setPageCount(prev => ++prev) }} className="btn active"><i className="fa fa-angle-double-right"
                                style={{ fontSize: ".8em" }} aria-hidden="true"></i></button></li>
                            </ul>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <p className="bg-dark text-white text-center py-4 mb-0">Gamal technologies &copy; {present.current}</p>
      </footer>
    </React.Fragment>
  );
}

export default App;
